<template>

    <v-menu
            offset-y
            :top="!showUnder"
            :bottom="showUnder"
            :close-on-content-click="false"
            :close-on-click="true"
            :nudge-bottom="showUnder ? 10 : 0"
            :nudge-top="!showUnder ? 10 : 0"
            v-model="editorModel"
            :allow-overflow="true"
            :min-width="isContentLong ? 900 : 700">

        <template v-slot:activator="{ on }">

            <div @click="clickedActivator" class="cursor-pointer">
                <slot></slot>
            </div>

        </template>

        <v-card color="white" min-height="300" style="opacity: 0.95;">

            <v-alert tile class="mb-0 pa-1 body-2" type="info">
                This field supports Markdown.
                <span v-html="markdownInfoLink"></span>
            </v-alert>

            <v-card-text class="pt-0">

                <v-textarea
                        light
                        :rows="isContentLong ? 20 : 10"
                        row-height="24"
                        v-model="textModel"
                        :hint="hint"
                        persistent-hint
                        class="mt-0"
                >
                </v-textarea>
            </v-card-text>
        </v-card>

    </v-menu>

</template>

<script>
    import VueMarkdown from '@adapttive/vue-markdown';

    export default {

        components: {
            VueMarkdown
        },

        props: {
            value: {
                type: String | null,
                required: true,
            },
            hint: {
                type: String,
                required: false,
                default: '',
            },
            markdown: {
                type: Boolean,
                required: false,
                default: false,
            },
            showUnder: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                markdownInfoLink: '<a class="white--text" href="https://www.markdownguide.org/basic-syntax/#overview" target="_blank">Learn more</a>',
                editorModel: false,
            }
        },

        computed: {

            isContentLong() {
                if (!this.value) return false;
                return this.value.length > 1000;
            },

            textModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
        },

        methods: {
            clickedActivator() {
                this.editorModel = true;
            }
        }
    }
</script>

<style scoped>
    .v-menu__content {
        min-height: 300px;
    }
</style>
